module.exports = __webpack_public_path__ + "img/productp11.11a3b88c.png";